export const RESET = 'containers/LoginBox/RESET';
export const CHANGE_INPUT = 'containers/LoginBox/CHANGE_INPUT';
